import React from 'react';

/**
 * 🛡️ Xavfsizlik tahlili uchun AI modeli — GLOBAL sozlama (Konfiguratsiya tabi).
 *
 * Ikki guruh: **Claude Max** (bepul — Khorezmai obunasi orqali) va **OpenRouter**
 * (pullik, narxi ko'rsatiladi). Tanlov barcha xavfsizlik skanlariga (qo'lda va
 * avtomatik) qo'llanadi.
 *
 * `authFetch` har render'da yangi identity — effekt dep'iga QO'YILMAYDI.
 */
export default function SecurityModelCard({ authFetch, apiUrl, isAdmin }) {
  const [data, setData] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [q, setQ] = React.useState('');
  const afRef = React.useRef(authFetch);
  afRef.current = authFetch;

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await afRef.current(`${apiUrl}/security/ai-models`);
        const j = await r.json().catch(() => null);
        if (alive && r.ok && j) setData(j);
      } catch { /* sozlanmagan bo'lsa karta ko'rinmaydi */ }
    })();
    return () => { alive = false; };
  }, [apiUrl]);

  async function save(model) {
    setBusy(true); setMsg('');
    try {
      const r = await afRef.current(`${apiUrl}/security/ai-model`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ model }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) setMsg('❌ ' + (j.error || 'Saqlanmadi'));
      else { setData(d => ({ ...d, current: model })); setMsg(j.free ? '✅ Saqlandi — bu model bepul (Max)' : '✅ Saqlandi — bu model PULLIK (OpenRouter)'); }
    } catch (e) { setMsg('❌ ' + e.message); } finally { setBusy(false); setTimeout(() => setMsg(''), 5000); }
  }

  if (!data) return null;
  const all = data.models || [];
  const max = all.filter(m => m.source === 'max');
  const or = all.filter(m => m.source === 'openrouter');
  const needle = q.trim().toLowerCase();
  // OpenRouter katalogi 400+ model — qidiruvsiz ro'yxat foydasiz bo'lardi.
  const orShown = needle ? or.filter(m => m.id.toLowerCase().includes(needle) || (m.name || '').toLowerCase().includes(needle))
                         : or.filter(m => /claude/i.test(m.id));
  const cur = all.find(m => m.id === data.current);
  const price = (m) => (m && m.promptPrice != null)
    ? `$${m.promptPrice.toFixed(2)}/M kirish · $${(m.completionPrice || 0).toFixed(2)}/M chiqish` : '';

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 mt-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">🛡️ Xavfsizlik tahlili uchun model</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-2xl">
            Skan topilmalarini tushuntirish va tuzatish yo'lini yozish uchun ishlatiladi.
            <b> Max</b> modellari obunangiz hisobidan — <b>qo'shimcha to'lov yo'q</b>.
            <b> OpenRouter</b> modellari esa har chaqiruv uchun pul yechadi.
          </p>
        </div>
        <div className="text-right text-sm shrink-0">
          {cur && (
            <span className={`px-2.5 py-1 rounded-lg font-medium ${cur.source === 'max' ? 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400' : 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400'}`}>
              {cur.source === 'max' ? '💚 bepul (Max)' : '💳 pullik'}
            </span>
          )}
        </div>
      </div>

      <div className="mt-4 flex items-center gap-3 flex-wrap">
        <select value={data.current} disabled={busy || !isAdmin}
          onChange={(e) => save(e.target.value)}
          className="border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm min-w-[22rem] disabled:opacity-60">
          <optgroup label="Claude Max — bepul">
            {max.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
          </optgroup>
          <optgroup label={needle ? `OpenRouter — qidiruv "${q}"` : 'OpenRouter — pullik (Claude modellari)'}>
            {orShown.map(m => (
              <option key={m.id} value={m.id}>{m.id}{price(m) ? ` — ${price(m)}` : ''}</option>
            ))}
          </optgroup>
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="OpenRouter modelini qidirish…"
          className="border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm w-64" />
        <span className="text-xs text-gray-400">{or.length} ta OpenRouter modeli mavjud</span>
      </div>

      {msg && <div className="mt-3 text-sm text-gray-700 dark:text-gray-300">{msg}</div>}
      {!isAdmin && <div className="mt-3 text-xs text-gray-400">O'zgartirish faqat admin uchun.</div>}
    </div>
  );
}
